// page/System/router.js
// System菜单下管理的路由文件
export default [{
		path: '/systemcountry',
		component: () => import('./country.vue'),
		name: 'country',
		meta: {
			title: 'Sidebar.systemsubsTitle[0]'
		}
	},
	{
		path: '/systemunit',
		component: () => import('./unit.vue'),
		name: 'unit',
		meta: {
			title: 'Sidebar.systemsubsTitle[1]'
		}
	},
	{
		path: '/systemapproval',
		component: () => import('./approval.vue'),
		name: 'sysapproval',
		meta: {
			title: 'Sidebar.systemsubsTitle[2]'
		}
	},
	{
		path: '/systemDataSetting',
		component: () => import('./SystemDataSetting.vue'),
		name: 'systemDataSetting',
		meta: {
			title: 'Sidebar.systemsubsTitle[3]'
		}
	},
	{
		path: '/systemCurrencyConversion',
		component: () => import('./CurrencyConversion.vue'),
		name: 'CurrencyConversion',
		meta: {
			title: 'Sidebar.systemsubsTitle[4]'
		}
	},
	{
		path: '/systemApprovalLevelSetting',
		component: () => import('./ApproverSetting.vue'),
		name: 'ApprovalLevelSetting',
		meta: {
			title: 'Sidebar.systemsubsTitle[5]'
		}
	},
	{
		path: '/systemSettingGroupMenuList',
		component: () => import('./SettingGroupMenuList.vue'),
		name: 'SettingGroupMenuList',
		meta: {
			title: 'Sidebar.systemsubsTitle[6]'
		}
	}
];



// WEBPACK FOOTER //
// ./src/components/page/System/router.js